import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "checkbox-wrapper" }
const _hoisted_2 = { class: "checkbox-button" }
const _hoisted_3 = ["checked", "disabled"]
const _hoisted_4 = {
  key: 0,
  class: "text"
}

import { ref, computed } from "vue";
import IconCheck from "@/icons/IconCheck.vue";

export type CheckboxSize = "M" | "L";

export interface Props {
  modelValue: boolean;
  label?: string;
  disabled?: boolean;
  size?: CheckboxSize;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseCheckbox',
  props: {
    modelValue: { type: Boolean },
    label: { default: "" },
    disabled: { type: Boolean },
    size: { default: "M" }
  },
  emits: ["update:model-value"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const isHover = ref(false);

const inputClasses = computed(() => ({
  hover: isHover.value,
  disabled: props.disabled,
  [props.size]: true,
}));

const onChange = (e: Event) => {
  const target = e.target as HTMLInputElement;
  emit("update:model-value", target.checked);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: _normalizeClass(["checkbox-label row", { disabled: _ctx.disabled }]),
      onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (isHover.value = true)),
      onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (isHover.value = false))
    }, [
      _createElementVNode("span", _hoisted_2, [
        _createElementVNode("input", {
          class: _normalizeClass(["checkbox-input", { checked: _ctx.modelValue }]),
          type: "checkbox",
          checked: _ctx.modelValue,
          disabled: _ctx.disabled,
          onInput: onChange
        }, null, 42, _hoisted_3),
        _createElementVNode("span", {
          class: _normalizeClass(["checkbox-image", inputClasses.value])
        }, [
          (_ctx.modelValue)
            ? (_openBlock(), _createBlock(IconCheck, {
                key: 0,
                class: "icon"
              }))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.label), 1))
        : _createCommentVNode("", true)
    ], 34)
  ]))
}
}

})